import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-20 pb-12 border-t border-brand-gray">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
        {/* Brand & Logo */}
        <div className="flex flex-col space-y-4">
          <Link to="/" className="flex flex-col w-fit transition-transform duration-300 hover:scale-[1.03]">
            <span className="text-xl font-light tracking-[0.2em] text-white uppercase font-display mr-[-0.2em]">
              Heine Design
            </span>
            <div className="h-[1px] w-full bg-white/30 my-1" />
            <div 
              className="flex justify-between w-full text-[7px] text-white/90 uppercase font-medium font-display"
              aria-label="Dansk håndværk og design"
            >
              {"Dansk håndværk og design".toUpperCase().split("").map((char, i) => (
                <span key={i} aria-hidden="true" className="select-none">
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </div>
          </Link>
          <p className="text-xs text-white/70 leading-relaxed max-w-sm">
            Eksklusive håndlavede møbler og specialdesignede løsninger i dansk kvalitet. Heine Design kombinerer traditionelt håndværk med moderne design.
          </p>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col space-y-4">
          <h4 className="text-xs tracking-[0.25em] uppercase text-white font-semibold">
            Kontakt
          </h4>
          <ul className="space-y-2 text-xs text-white/90">
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-location-dot text-white w-4" />
              <span>Klarkærvej 12, 4600 Køge, Denmark</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-white w-4" />
              <a href="tel:+4522443585" className="hover:text-white/70 transition-colors duration-300">
                +45 22 44 35 85
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-white w-4" />
              <a href="mailto:info@heinedesign.com" className="hover:text-white/70 transition-colors duration-300">
                info@heinedesign.com
              </a>
            </li>
          </ul>
        </div>

        {/* Quick Navigation */}
        <div className="flex flex-col space-y-4">
          <h4 className="text-xs tracking-[0.25em] uppercase text-white font-semibold">
            Navigation
          </h4>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <Link to="/" className="text-white/80 hover:text-white transition-colors duration-300">
              Home
            </Link>
            <Link to="/produkter" className="text-white/80 hover:text-white transition-colors duration-300">
              Furniture
            </Link>
            <Link to="/profil" className="text-white/80 hover:text-white transition-colors duration-300">
              Profile
            </Link>
            <a href="https://www.instagram.com/heinedesign/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors duration-300">
              Instagram
            </a>
            <Link to="/kontakt" className="text-white/80 hover:text-white transition-colors duration-300">
              Contact
            </Link>
            <Link to="/tidligere-annoncer" className="text-white/80 hover:text-white transition-colors duration-300">
              Annoncer
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 pt-8 border-t border-brand-gray flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-white/60 tracking-wider">
        <p>© {currentYear} Heine Design. Alle rettigheder forbeholdes.</p>
        <div className="flex items-center gap-4 sm:gap-6">
          <a
            href="https://www.instagram.com/heinedesign/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors duration-300 flex items-center gap-1.5"
            aria-label="Heine Design Instagram (Møbler)"
          >
            <i className="fa-brands fa-instagram text-base" />
            <span>Instagram (Møbler)</span>
          </a>
          <span className="text-white/20">|</span>
          <a
            href="https://www.instagram.com/toemmertonyheine/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors duration-300 flex items-center gap-1.5"
            aria-label="Tømrer Tony Heine Instagram (Tømrerforretning)"
          >
            <i className="fa-brands fa-instagram text-base" />
            <span>Instagram (Tømrer)</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
